"use client";

import type {
  MFAChallengeResponse,
  EmailVerificationRequiredResponse,
  AuthResponse,
} from "@/lib/api/model";

export type LoginData =
  | AuthResponse
  | MFAChallengeResponse
  | EmailVerificationRequiredResponse;

export function isMfaChallenge(data: unknown): data is MFAChallengeResponse {
  return (
    typeof data === "object" &&
    data !== null &&
    "mfa_challenge" in data &&
    (data as MFAChallengeResponse).mfa_challenge === true
  );
}

export function isEmailVerificationRequired(
  data: unknown
): data is EmailVerificationRequiredResponse {
  return (
    typeof data === "object" &&
    data !== null &&
    "email_verification_required" in data &&
    (data as EmailVerificationRequiredResponse)
      .email_verification_required === true
  );
}
